export default __webpack_public_path__ + "static/media/mindbowser.75a0c980.jpg";